import dayjs from 'dayjs';
export class ActivityCalendarDate {
    constructor(date, isWatched, freezeUsed) {
        Object.defineProperty(this, "date", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isWatched", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "freezeUsed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.date = date;
        this.isWatched = isWatched;
        this.freezeUsed = freezeUsed;
    }
    get isChecked() {
        return this.isWatched || this.freezeUsed;
    }
    static createList(lastDateOfMonth, activities, freezeUsedDates) {
        const watchedDates = ActivityCalendarDate.buildWatchedDateSet(activities);
        const freezeUsedDateNumbers = ActivityCalendarDate.buildFreezeUsedDateSet(freezeUsedDates);
        return Array.from({ length: lastDateOfMonth }, (_, index) => {
            const date = index + 1;
            return new ActivityCalendarDate(date, watchedDates.has(date), freezeUsedDateNumbers.has(date));
        });
    }
    static buildWatchedDateSet(activities) {
        const watchedDates = activities
            .map((activityDate) => dayjs(activityDate))
            .filter((parsedDate) => parsedDate.isValid())
            .map((validDate) => validDate.date());
        return new Set(watchedDates);
    }
    static buildFreezeUsedDateSet(freezeUsedDates) {
        const freezeUsedDateNumbers = freezeUsedDates
            .map((freezeUsedDate) => dayjs(freezeUsedDate))
            .filter((parsedDate) => parsedDate.isValid())
            .map((validDate) => validDate.date());
        return new Set(freezeUsedDateNumbers);
    }
}
